import * as React from 'react';

import { message as m } from 'antd';
import { Subscription } from 'rxjs';

import { Notification } from '@atoms/notification';
import { GlobalConstants } from '@constants/global';

import { messageService } from '../../classes/messageService';
import { TNotification } from '../../types/notification';

type State = {
    items: Array<TNotification & { key: string }>;
};

class NotificationBar extends React.Component<{}, State> {
    subscription: Subscription;

    constructor(props: {}) {
        super(props);
        this.state = { items: [] };
    }

    componentDidMount() {
        this.subscription = messageService.getMessage().subscribe((value: TNotification | null) => {
            if (value == null) {
                this.clearAllMessages();
            } else {
                this.addMessage(value);
            }
        });
    }

    componentWillUnmount() {
        this.subscription.unsubscribe();
    }

    addMessage(message: TNotification) {
        const key = Date.now() + Math.random().toString();

        const newMessage = { ...message, key };
        this.setState(
            (prev) => ({ items: [...prev.items, newMessage] }),
            () => this.showMessage(newMessage)
        );
    }

    showMessage(message: TNotification & { key: string }) {
        const duration = GlobalConstants.notificationDuration;

        m.open({
            type: message.type,
            content: (
                <Notification duration={duration} message={message.text} type={message.type} />
            ),
            duration,
            key: message.key,
            onClick: () => this.delMessage(message.key),
            onClose: () => this.delMessage(message.key),
        });
    }

    delMessage(key: string) {
        this.setState((prev) => ({
            items: prev.items.filter((msg) => msg.key !== key),
        }));
        m.destroy(key);
    }

    clearAllMessages() {
        this.setState({ items: [] });
        m.destroy();
    }

    render() {
        return null;
    }
}

export { NotificationBar };
